(function () {
  'use strict';

  var SELECTOR = '[data-product-card-carousel]';
  var DEFAULT_SPEED_SECONDS = 5;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselInitialized === 'true') return;
    carousel.dataset.carouselInitialized = 'true';

    var slider = carousel.querySelector('[id^="Slider-"]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[id^="Slide-"]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(carousel.querySelectorAll('.slider-counter__link'));
    var speedValue = parseInt(slider.dataset.speed || DEFAULT_SPEED_SECONDS, 10);
    var intervalMs = (isFinite(speedValue) && speedValue > 0 ? speedValue : DEFAULT_SPEED_SECONDS) * 1000;
    var currentIndex = 0;
    var timer = null;
    var scrollRaf = null;
    var isHovered = false;

    function getSlideOffset() {
      if (slides.length < 2) return slides[0].clientWidth || 0;
      var offset = slides[1].offsetLeft - slides[0].offsetLeft;
      return offset || slides[0].clientWidth || 0;
    }

    function updateDots(index) {
      if (!dots.length) return;
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function goTo(index, behavior) {
      var clamped = (index + slides.length) % slides.length;
      currentIndex = clamped;
      slider.scrollTo({
        left: slides[clamped].offsetLeft,
        behavior: behavior || 'smooth',
      });
      updateDots(clamped);
    }

    function start() {
      if (timer || !isHovered) return;
      timer = setInterval(function () {
        goTo(currentIndex + 1);
      }, intervalMs);
    }

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    function handleScroll() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = null;
        var offset = getSlideOffset();
        if (!offset) return;
        var nextIndex = Math.round(slider.scrollLeft / offset);
        if (nextIndex !== currentIndex) {
          currentIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
          updateDots(currentIndex);
        }
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index);
        stop();
        start();
      });
    });

    carousel.addEventListener('mouseenter', function () {
      isHovered = true;
      start();
    });

    carousel.addEventListener('mouseleave', function () {
      isHovered = false;
      stop();
    });

    slider.addEventListener('scroll', handleScroll);
    updateDots(currentIndex);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
